import React from 'react';
import { Button, Box, useWidth } from 'vindi-ds-components';
import styles from './styles';
import mobileStyles from './mobile/styles';

function Action({ action, path, variant }) {
  const breakpoint = useWidth();
  let stylesCss = styles;

  if (['xs', 'sm'].includes(breakpoint)) {
    stylesCss = mobileStyles;
  }

  return (
    <Box css={stylesCss.action}>
      <Button href={path} variant={variant} style={stylesCss.actionLink}>
        {action}
      </Button>
    </Box>
  );
}

export default Action;
